import * as React from 'react';
import { PK } from 'common/types';

type Props = {
  pk?: PK | null;
  collectionItems?: PK[] | null;
  children?: React.ReactNode;
};

const SectionsWrapper = ({ pk, collectionItems, children }: Props) => {
  return (
    <>
      {React.Children.map(children, (child) =>
        React.isValidElement(child)
          ? React.cloneElement(child, { pk, collectionItems })
          : child,
      )}
    </>
  );
};

export default SectionsWrapper;
